import Image from '@/components/UI/Image';
import EFShoppingCart from '@/components/UI/svg/LandingPage/EFShoppingCart';
import { useGlobal } from '@/utils/useGlobal';
import C from '@elem/compPage/DeltaProUltra/Launch/Detail/components/C';
import { TweenMax } from 'gsap';
import { ReactNode, useEffect } from 'react';
import css from './index.module.scss';
export default function EC({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const SHOW_CART_SITE = ['sa', 'za', 'au'].includes(locale);
    const IS_NA_SITES = ['us', 'ca'].includes(locale);

    useEffect(() => {
        if (!IS_NA_SITES) {
            const controller = new ScrollMagic.Controller();

            const sceneA1 = new ScrollMagic.Scene({
                triggerElement: '.expandableCapacity .box1',
                offset: '50px', //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '10%', //和滚动条绑定到一起,场景持续滚动距离为 800px
            });

            const sceneA2 = new ScrollMagic.Scene({
                triggerElement: '.expandableCapacity .box-line1',
                offset: '50px', //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '10%', //和滚动条绑定到一起,场景持续滚动距离为 800px
            });

            const sceneA3 = new ScrollMagic.Scene({
                triggerElement: '.expandableCapacity .box-line2',
                offset: '50px', //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '10%', //和滚动条绑定到一起,场景持续滚动距离为 800px
            });

            const tweenA1 = TweenMax.fromTo(
                '.expandableCapacity .box1',
                1,
                { opacity: 0 },
                {
                    opacity: 1,
                    ease: 'linear',
                },
            );
            const tweenA2 = TweenMax.fromTo(
                '.expandableCapacity .box-line1',
                1,
                { opacity: 0 },
                {
                    opacity: 1,
                    ease: 'linear',
                },
            );
            const tweenA3 = TweenMax.fromTo(
                '.expandableCapacity .box-line2',
                1,
                { opacity: 0 },
                {
                    opacity: 1,
                    ease: 'linear',
                },
            );

            sceneA1.setTween(tweenA1);
            sceneA2.setTween(tweenA2);
            sceneA3.setTween(tweenA3);

            controller.addScene(sceneA1);
            controller.addScene(sceneA2);
            controller.addScene(sceneA3);
        }
    }, []);

    return (
        <div className={`${css.expandableCapacity} expandableCapacity`}>
            {!IS_NA_SITES && (
                <>
                    <div className="box1">
                        <Image
                            src={`/img/landingPage/h5/expandable${SHOW_CART_SITE ? '2' : ''}.png`}
                            noUseSrcset
                            className="fullImgs"
                            layout="fill"
                            alt={'expandable'}
                        />
                        <div className="title">{t('delta_pro_whole_home.box1_title')}</div>
                    </div>
                    <div className="box-line box-line1">
                        <div className="box2">
                            <Image src="/img/landingPage/h5/box2.png" noUseSrcset className="fullImgs" layout="fill" alt={'expandable'} />
                            <div className="title">
                                {t.rich('delta_pro_whole_home.box2_title', {
                                    line1: (child: ReactNode) => <div>{child} </div>,
                                    line2: (child: ReactNode) => <div className="high-light">{child} </div>,
                                })}
                            </div>
                        </div>
                        <div className="box3">
                            <div className="img-box">
                                <Image src="/img/landingPage/h5/box3.png" noUseSrcset className="fullImgs" layout="fill" alt={'expandable'} />
                            </div>
                            <div className="title">
                                {t.rich('delta_pro_whole_home.box3_title', {
                                    line1: (child: ReactNode) => <div>{child} </div>,
                                    line2: (child: ReactNode) => <div>{child} </div>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="box-line box-line2">
                        {!SHOW_CART_SITE && (
                            <>
                                <div className="box4">
                                    <Image src="/img/landingPage/h5/charging.png" noUseSrcset className="fullImgs" layout="fill" alt={'expandable'} />
                                    <div className="title">
                                        {t.rich('delta_pro_whole_home.box4_title', {
                                            line1: (child: ReactNode) => <div>{child} </div>,
                                            line2: (child: ReactNode) => <div>{child} </div>,
                                            line3: (child: ReactNode) => <div>{child} </div>,
                                        })}
                                    </div>
                                </div>
                                <div className="box5">
                                    <Image src="/img/landingPage/h5/box5.png" noUseSrcset className="fullImgs" layout="fill" alt={'expandable'} />
                                    <div className="title">
                                        {t.rich('delta_pro_whole_home.box5_title', {
                                            line1: (child: ReactNode) => <div>{child} </div>,
                                            line2: (child: ReactNode) => <div>{child} </div>,
                                        })}
                                    </div>
                                </div>
                            </>
                        )}
                        {SHOW_CART_SITE && (
                            <>
                                <div className="box6">
                                    <EFShoppingCart width="30px" height="30px" />
                                    <div className="title">{t('secD_item_3_cart')}</div>
                                </div>
                                <div className="box7">
                                    <Image src="/img/landingPage/h5/charging2.png" noUseSrcset className="fullImgs" layout="fill" alt={'expandable'} />
                                    <div className="title">
                                        {t.rich('delta_pro_whole_home.box4_title', {
                                            line1: (child: ReactNode) => <p>{child} </p>,
                                            line2: (child: ReactNode) => <p>{child} </p>,
                                            line3: (child: ReactNode) => <p>{child} </p>,
                                        })}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    {locale === 'au' && <p className="memo">{t('secD_memo')}</p>}
                </>
            )}
            {IS_NA_SITES && <C langKey="landingPage" />}
        </div>
    );
}
